import actions from '../../actionTypes';

export default tag => {
  return {
    type: actions.EDIT_TAG,
    tag
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/editTag.js